// crewbit-admin/src/components/money/clients/ClientDefaultsRow.tsx
//
// Tier 2-UI Phase D-admin §WorldClass.1 — layout primitive for the
// MoneyDefaultsSection rows (client edit) and the read-only pre-fill rows
// on invoice authoring AuthoringReviewSection. Mirrors mobile body shape:
// header row (label + pill) above the editor + optional helper microcopy
// below.

import type { ReactNode } from 'react';
import { palette, spacing, typography } from '../../../styles/tokens';

interface Props {
  label: string;
  pill?: ReactNode;
  children: ReactNode;
  helper?: string;
}

export default function ClientDefaultsRow({ label, pill, children, helper }: Props) {
  return (
    <div
      style={{
        paddingBlock: spacing.sm,
        display: 'flex',
        flexDirection: 'column',
        gap: spacing.xs,
      }}
    >
      <div
        style={{
          display: 'flex',
          alignItems: 'center',
          justifyContent: 'space-between',
          gap: spacing.sm,
        }}
      >
        <div
          style={{
            fontSize: typography.size.subheading,
            fontWeight: typography.weight.semibold,
            color: palette.g700,
            flexShrink: 1,
          }}
        >
          {label}
        </div>
        {pill}
      </div>
      <div style={{ marginTop: 2 }}>{children}</div>
      {helper && (
        <div
          style={{
            fontSize: typography.size.caption,
            color: palette.g500,
          }}
        >
          {helper}
        </div>
      )}
    </div>
  );
}
